module.exports = __webpack_public_path__ + "img/8.1727002d.jpg";